import {
	create,
	evaluateDependencies,
	addDependencies,
	divideDependencies,
	formatDependencies,
	roundDependencies,
	ceilDependencies,
	floorDependencies,
	multiplyDependencies,
} from "mathjs/number";
const config = {
	// optionally, you can specify configuration
};
// Create just the functions we need
const mathjs = create(
	{
		evaluateDependencies,
		addDependencies,
		divideDependencies,
		formatDependencies,
		roundDependencies,
		ceilDependencies,
		floorDependencies,
		multiplyDependencies,
	},
	config,
);
window.ydmath = mathjs;
